import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { PlatformResponse } from 'src/app/interfaces/webservices-interface';
import { CustomerModel } from 'src/app/models/customer-model';
import { ConfigService } from '../config/config.service';
import { EventsService } from '../event/event.service';
import { LogoutService } from '../logout/logout.service';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';
import { JurisdictionService } from '../geo/jurisdiction.service';
declare var EventSourcePolyfill: any;

export interface NotificationEventInterface {
  htmlText?: string;
  notificationLink?: string;
  notificationImage?: string;
  id: number;
  status: string;
  text: string;
  title: string;
  type: string;
  customField3: string;
  customField4: string;
  customField5: string;
  parametersMap: {
      gameTypeIds: string;
      amount: string;
      currency: string;
      winner: string;
      netWinAmount? : number;
      winLossText: string;
      numberOfEntry: number;
      numberOfSpinLeft: number;
  }
}

export interface NotificationErrorInterface {

}

@Injectable({
  providedIn: 'root'
})
export class NotificationApiService {

  readonly LISTENER_EVENT_TYPE = 'instant_notification';

    protected _eventSubject: Subject<any>;
    protected _eventSource: EventSource;
    protected _sessionToken = "0";
    private isPaused: boolean = false;
    private messageBuffer: Array<any>;

    protected retryNr = 0; //@todo config
    protected retryTime = null; //@todo config
    protected retryNrAllowed; //@todo config
    protected retryTimeAllowed; //@todo config


    constructor(
        private configService: ConfigService,
        private userSessionService: UserSessionService,
        private webservice: WebservicesService,
        private logoutService: LogoutService,
        private eventsService: EventsService,
        private jurisdictionService: JurisdictionService,
    ) {
        this._eventSubject = new Subject<any>();

        this.retryNrAllowed =   ~~this.configService.getConfig().FEATURE_NOTIFICATIONS_RETRY_NR || 10;
        this.retryTimeAllowed = ~~this.configService.getConfig().FEATURE_NOTIFICATIONS_RETRY_TIME || 15000;
    }

    /**
     * Returns an Observable event stream of messages that shouold be displayed to the user.
     */
    public listen() {
        this.messageBuffer = [];
        this.userSessionService.getCustomer().subscribe((customer) => {
            let session_token = this.userSessionService.getSessionToken();
            if (session_token && this._sessionToken !== session_token) {
                this._sessionToken = session_token;
                this.initialize(this.LISTENER_EVENT_TYPE, session_token);
            }
        });

        return this._eventSubject;
    }

    public pause() {
        console.warn('notification-api: pausing');
        this.isPaused = true;
    }

    public resume() {
        console.warn('notification-api: resuming');
        this.isPaused = false;
        this.drainBuffer();
    }

    protected emit(msg) {
        if (this.isPaused) {
            this.messageBuffer.push(msg);
        } else {
            this._eventSubject.next(msg);
        }
    }

    protected drainBuffer() {
        this.isPaused = false;
        setTimeout(() => {
            console.warn('notification-api: draining...');
            while (this.messageBuffer.length > 0) {
                let msg = this.messageBuffer.shift();
                this._eventSubject.next(msg);
            }
        }, 1 * 1000);
    }

    public unsubscribe() {
        if (this._eventSource) {
            this._eventSource.close();
        }
    }
    theSubject() {
        return this._eventSubject;
    }
    //
    protected check_session_retries: number = 0;
    protected checkSession(): Promise<any> {
      this.check_session_retries = 0;
      return new Promise((resolve, reject) => {
        if (localStorage.getItem('userSession.customer') === null) reject('INVALID_SESSION_TOKEN')
        // const authenticatedCustomer = new Promise((resolve)=> localStorage.getItem('userSession.customer'));
        this.authenticatedCustomer()
        .then((customerDataUnparsed: string) => {
            if (customerDataUnparsed) {
              const customer: CustomerModel = JSON.parse(customerDataUnparsed);
              this.webservice
                .get("authentication/check-session", {
                  customer_id: customer.customerId,
                  session_token: this.userSessionService.sessionToken,
                })
                .subscribe(
                  (response: PlatformResponse<any>) => {
                    this.check_session_retries = 0;
                    console.log(
                      "notification-api.ts: check-session response: ",
                      response
                    );
                    if (response.result) {
                      resolve(response);
                    } else {
                      reject("INVALID_SESSION_TOKEN");
                    }
                  },
                  (err) => {
                    console.log("notification-api.ts: webservice error: ", err);
                    if (++this.check_session_retries < 10) {
                      setTimeout(() => {
                        this.checkSession().then((response) => {
                          resolve(response);
                        });
                      }, 2000);
                    }
                  }
                );
            } else {
              reject('INVALID_SESSION_TOKEN');
            }
          })
      });
    }

    authenticatedCustomer = () =>  {
        return new Promise((resolve)=> {
            console.log("notification session check...")
            resolve(localStorage.getItem('userSession.customer'))
        });
    }

    protected async initialize(event_type: string, session_token: string) {
        //
        let EventSource = window['EventSource'] || EventSourcePolyfill;

        //
        var url = this.configService.getConfig().NOTIFICATION_BASEURL + '/notificationapi/resources/player_notification/subscribe?session_id=' + session_token;
        this._eventSource = new EventSource(url, { withCredentials: false });

        this._eventSource.onerror = (e: any) => {
            console.warn('notification-api.ts: subscription got error, error:', e);
            this._eventSource.close();
            this.checkSession().then( async (response) => {
                console.log('notification-api.ts: response: ', response);

                if (this.isAllowedToReInit()) {
                    await this.initialize(event_type, session_token);
                    const MFAStatus = (localStorage.getItem('userSession.mfa') != 'true');
                    if (MFAStatus) {
                      //IPCheck detection added in jurisdiction file 
                      //this.jurisdictionService.resetGeolocationIntervals();
                    }
                }
            }).catch((err) => {
                console.error('notification-api.ts: err:', err);
                this.eventsService.publish( 'event:authentication:logout')
            });
        };

        this._eventSource.onopen = (e: any) => {
            this._eventSource.addEventListener(event_type, (e: any) => {
                this.dispatch(JSON.parse(e.data));
            }, false);
            this._eventSource.addEventListener('close', (e: any) => {
                this._eventSource = null;
            }, false);
        };

        //        this._eventSource.addEventListener( 'error', (e: any) => {
        //            console.warn( 'notification-api.ts: subscription was closed, event:', e);
        //            this.initialize( event_type, session_token);
        //        }, false);

    }

    private isAllowedToReInit() {
        if (this.retryTime == null) this.retryTime = Date.now();
        if ( Date.now() - this.retryTime < this.retryTimeAllowed ) {
            if( this.retryNr >= this.retryNrAllowed ) {
                this.retryTime = null;
                this.retryNr = 0;
                this.logoutService.onLogout()
                //Navigator.navigateTo("LogoutPage", {}, { code: 'RUNNING_MULTIPLE_TABS', reason: 'RUNNING_MULTIPLE_TABS' });
                return false;
            }
        } else {
            this.retryTime = null;
            this.retryNr = 0;
        }

        this.retryNr++;
        return true;
    }

    protected dispatch(e: NotificationEventInterface) {
        // dispatch event to listener (notification component can listen and manage event workflow)
        this.emit(e);
    }
}
